
import {JOB_DESCRIPTION_REQUEST, JOB_DESCRIPTION_SUCCESS,JOB_DESCRIPTION_FAIL,UPDATE_ACCEPT_REQUEST, UPDATE_ACCEPT_SUCCESS,UPDATE_ACCEPT_FAIL,UPDATE_REJECT_REQUEST, UPDATE_REJECT_SUCCESS,UPDATE_REJECT_FAIL} from "../constants/AuthConstant"
import { toast } from "react-toastify";
const axios = require("axios");

export const JobDescriptionAll = (id) => {

    return function (dispatch) {
      dispatch({
        type: JOB_DESCRIPTION_REQUEST,
        payload: true,
      });
     
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_applied_jobs_details?appliedJobsId=${id}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
            console.log(res.data,"helloView")
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: JOB_DESCRIPTION_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  
  export const loadAllDetailsPre = (data) => {
    return {
      type: JOB_DESCRIPTION_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  
export const UpdateAccept = (data) => {
  return function (dispatch) {
    dispatch({
      type: UPDATE_ACCEPT_REQUEST,
      payload: true,
    });

    let OPTION = {
       url: `${process.env.REACT_APP_API_PATH}/ebench/accept_or_reject_job`,
      method: "PUT",
      data: data, 
      headers: {
        "content-type": "application/json",       
      },
    };

    axios(OPTION)
      .then((res) => {
        dispatch(UpdateAcceptpre(res.data));
      })
      .catch((error) => {
        toast.error(error.response.data.status.message);
        dispatch({
          type: UPDATE_ACCEPT_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
       
      });
  };
};

export const UpdateAcceptpre = (data) => {
   toast.success("Thank You For Accepting ");
  return {
    type: UPDATE_ACCEPT_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};

export const UpdateReject = (data) => {
  return function (dispatch) {
    dispatch({
      type: UPDATE_REJECT_REQUEST,
      payload: true,
    });

    let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/accept_or_reject_job`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    axios(OPTION)
      .then((res) => {
        dispatch(UpdateRejectpre(res.data));
      })
      .catch((error) => {
        toast.error(error.response.data.status.message);
        dispatch({
          type: UPDATE_REJECT_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
       
      });
  };
};
export const UpdateRejectpre = (data) => {
   toast.success("Rejected successfully!");
   setTimeout(() => {
    window.location.href = "/job-request";
},2000);
  
  return {
    type: UPDATE_REJECT_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};

  